(function () {
  const initializedSections = new WeakSet();

  const initStatsTabs = () => {
    const sections = document.querySelectorAll('[id^="stats-tabs-"]');

    sections.forEach((section) => {
      if (initializedSections.has(section)) {
        return;
      }
      initializedSections.add(section);

      const sectionId = section.id.replace('stats-tabs-', '');
      const tabs = section.querySelectorAll('.stats-tabs__tab');
      const stats = section.querySelectorAll('.stats-tabs__stat');
      const photos = section.querySelectorAll('.stats-tabs__photo');
      const dataScript = document.getElementById(`stats-tabs-data-${sectionId}`);

      if (!tabs.length || !stats.length || !dataScript) {
        console.warn('Stats Tabs: Missing required elements', { tabs: tabs.length, stats: stats.length, dataScript: !!dataScript });
        return;
      }

      let tabData = [];
      try {
        const data = JSON.parse(dataScript.textContent);
        tabData = data.tabs || [];
        console.log('Stats Tabs: Loaded tab data', tabData);
      } catch (e) {
        console.warn('Failed to parse tab data:', e);
        return;
      }

      if (tabData.length === 0) {
        console.warn('Stats Tabs: No tab data found');
        return;
      }

      // ====== STATS ANIMATION ======
      function animateNumber(el, prefix, target) {
        const end = parseInt(target, 10);
        if (isNaN(end)) return;
        const duration = 600;
        const start = performance.now();

        const tick = (now) => {
          const p = Math.min((now - start) / duration, 1);
          el.textContent = (prefix || '') + Math.round(end * p) + '%';
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }

      function applyFromTab(tabIndex) {
        const tab = tabData[tabIndex];
        if (!tab) {
          console.warn('Stats Tabs: No tab data at index', tabIndex);
          return;
        }

        // Update stats
        const prefixes = [tab.prefix1 || '', tab.prefix2 || '', tab.prefix3 || ''];
        const pcts = [tab.pct1 || '', tab.pct2 || '', tab.pct3 || ''];
        const labels = [tab.label1 || '', tab.label2 || '', tab.label3 || ''];
        const notes = [tab.note1 || '', tab.note2 || '', tab.note3 || ''];

        stats.forEach((line, i) => {
          const has = (pcts[i] || '').trim().length;
          if (!has) {
            line.style.display = 'none';
            return;
          }
          line.style.display = 'grid';

          const pctEl = line.querySelector('.stats-tabs__pct');
          const labelEl = line.querySelector('.stats-tabs__label');
          const noteEl = line.querySelector('.stats-tabs__note');

          if (!pctEl || !labelEl || !noteEl) {
            console.warn('Stats Tabs: Missing stat elements', { pctEl: !!pctEl, labelEl: !!labelEl, noteEl: !!noteEl });
            return;
          }

          labelEl.textContent = labels[i] || '';
          noteEl.textContent = notes[i] || '';
          noteEl.style.display = (notes[i] && notes[i].trim()) ? 'block' : 'none';

          pctEl.textContent = '';
          animateNumber(pctEl, prefixes[i], pcts[i]);
        });

        // Update image - show the image corresponding to this tab
        photos.forEach((photo) => {
          const photoTabIndex = parseInt(photo.dataset.tabImage, 10);
          photo.classList.toggle('is-active', photoTabIndex === tabIndex);
        });
      }

      // Initialize with first active tab
      const activeTab = section.querySelector('.stats-tabs__tab.is-active') || tabs[0];
      if (activeTab) {
        const tabIndex = parseInt(activeTab.dataset.tabIndex, 10);
        if (!isNaN(tabIndex)) {
          applyFromTab(tabIndex);
        }
      }

      // Tab click handlers
      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.remove('is-active'));
          tab.classList.add('is-active');

          const tabIndex = parseInt(tab.dataset.tabIndex, 10);
          console.log('Stats Tabs: Tab clicked', { tabIndex, idx, tabDataLength: tabData.length });
          if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < tabData.length) {
            applyFromTab(tabIndex);
          } else {
            console.warn('Stats Tabs: Invalid tab index', tabIndex);
          }
        }, { passive: true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStatsTabs);
  } else {
    initStatsTabs();
  }

  document.addEventListener('shopify:section:load', initStatsTabs);
})();
